import { Timestamp } from "firebase/firestore";
import { z } from "zod";

// The push-delivery bookkeeping (pushStatus, pushAttempts, …) lives on the same
// document but is deliberately not parsed here: it belongs to the sender
// trigger, and the inbox UI must not couple to it.
export const notificationSchema = z.object({
  // TRACK_SWITCH: the outcome of the reader's own table request (TNG-92).
  // CONNECTION: somebody scanned the reader's connect code (TNG-93).
  type: z.enum([
    "ANNOUNCEMENT",
    "EVENT_START",
    "AGENDA_CHANGE",
    "TRACK_SWITCH",
    // SEATING_TABLE: the reader's dinner table changed, or their seat change
    // request was answered (TNG-94).
    "SEATING_TABLE",
    "CONNECTION",
  ]),
  eventId: z.string(),
  eventSlug: z.string(),
  title: z.string(),
  body: z.string(),
  link: z.string(),
  createdAt: z.instanceof(Timestamp),
  readAt: z.instanceof(Timestamp).nullable(),
  // Set on an announcement that invites people to a feedback form; the detail
  // page then offers the in-app form.
  feedbackFormId: z.string().optional(),
});

export type Notification = z.infer<typeof notificationSchema> & { id: string };
